import {
  SAVE_TEMPLATE_CAT_RELEVANCE,
  SAVE_TEMPLATE_TOPIC_RELEVANCE,
  ADD_TEMPLATE_CATEGORY,
  REMOVE_TEMPLATE_CATEGORY,
  ADD_TEMPLATE_TOPIC,
  REMOVE_TEMPLATE_TOPIC,
  SAVE_TEMPLATE_CATEGORY_ORDER,
  SAVE_TEMPLATE_TOPIC_ORDER,
  SET_TEMPLATE_EDITING,
  SET_DEFAULT_TEMPLATES,
  SET_TEMPLATE_ERRORS_IDS,
  SET_USER_TEMPLATES,
  SAVE_TEMPLATE_TITLE,
  SET_USER_TEMPLATES_STATUS,
} from '../actions/action';

import { validateNumberInterval, parseOrder } from '../tools/tools';

import templateModel from '../models/template';


/*
0:
  _id: "5e1513ff360246306605d495"
  template: "1. Commercial traction"
  user: "5e149fa0b489f5ae2c946f76"
  categories: Array(9)
    0:
      topics: (2) [{…}, {…}]
        0:
          _id: "5e1513ff360246306605d4bc"
          topic: "Currency"
          descr: "Is the local currency stronger or weaker than ours? Is it stable?"
          relevance: 2
          order: 1
      _id: "5e1513ff360246306605d4ba"
      category: "Economic"
      relevance: 4
      order: 1
*/




const initialState = {
  editingTemplate: templateModel().final(),
  defaultTemplates: [],
  userTemplates: [],
  userTemplateStatus:'',
  errorIds:[] // ids of category/topic with error
}


export default (state = initialState, action) => {
  const {
    type,
    index,
    index1,
    relevance,
    category,
    // topic,
    topicObj,
    // descr='',
    template,
    title,
    userTemplateStatus='',
    errorIds
  } = action;
  let { order, defaultTemplates=[], userTemplates=[] } = action;

  const { editingTemplate } = state;

  if (type === SAVE_TEMPLATE_CAT_RELEVANCE) {
    const relevanceValid = validateNumberInterval(relevance);
    const newCats = state.editingTemplate.categories.map((cat, indexCat) => {
      if (indexCat === index) {
        cat.relevance = relevanceValid;
      }
      return { ...cat }
    });

    const newEditingTemplate=templateModel({ ...editingTemplate, categories: newCats });
    return { ...state, editingTemplate:  newEditingTemplate.final()}


  } else if (type === SAVE_TEMPLATE_CATEGORY_ORDER) {
    const newCats = state.editingTemplate.categories.map((cat, indexCat, array) => {
      if (indexCat === index) {
        order = parseOrder(order, array.length);
        cat.order = order;
      }
      return { ...cat }
    });
    const newEditingTemplate=templateModel({ ...editingTemplate, categories: newCats });
    return { ...state, editingTemplate: newEditingTemplate.final() }


  } else if (type === SAVE_TEMPLATE_TOPIC_RELEVANCE) {
    const relevanceValid = validateNumberInterval(relevance);
    const newCats = state.editingTemplate.categories.map((cat, indexCat) => {
      if (indexCat === index) {
        cat.topics = cat.topics.map((topic, indexTopic) => {
          if (indexTopic === index1) {
            topic.relevance = relevanceValid;
          }
          return { ...topic }
        });
      }
      return { ...cat }
    });

    const newEditingTemplate=templateModel({ ...editingTemplate, categories: newCats });
    return { ...state, editingTemplate: newEditingTemplate.final() }


  } else if (type === SAVE_TEMPLATE_TOPIC_ORDER) {
    const newCats = state.editingTemplate.categories.map((cat, indexCat) => {
      if (indexCat === index) {
        cat.topics = cat.topics.map((topic, indexTopic, array) => {
          if (indexTopic === index1) {
            order = parseOrder(order, array.length);
            topic.order = order;
          }
          return { ...topic }
        });
      }
      return { ...cat }
    });

    const newEditingTemplate=templateModel({ ...editingTemplate, categories: newCats });
    return { ...state, editingTemplate: newEditingTemplate.final() }


  } else if (type === ADD_TEMPLATE_CATEGORY) {
    const newCats = Array.from(state.editingTemplate.categories);

    newCats.push({category});

    const newEditingTemplate=templateModel({ ...editingTemplate, categories: newCats });
    return { ...state, editingTemplate: newEditingTemplate.final() }


  } else if (type === REMOVE_TEMPLATE_CATEGORY) {
    const newCats = state.editingTemplate.categories.filter((_,catIndex)=>catIndex!==index)

    const newEditingTemplate=templateModel({ ...editingTemplate, categories: newCats });
    return { ...state, editingTemplate: newEditingTemplate.final() }


  } else if(type === ADD_TEMPLATE_TOPIC) {
    const {_id,topic,descr}=topicObj;
    const newCats = state.editingTemplate.categories.map((cat, indexCat) => {
      if (indexCat === index) {
        cat.topics = Array.from(cat.topics);
        cat.topics.push({_id, topic, descr});
      }
      return { ...cat }
    });

    const newEditingTemplate=templateModel({ ...editingTemplate, categories: newCats });
    return { ...state, editingTemplate: newEditingTemplate.final() }


  } else if(type === REMOVE_TEMPLATE_TOPIC) {
    const newCats = state.editingTemplate.categories.map((cat, indexCat) => {
      if (indexCat === index) {
        cat.topics = cat.topics.filter((_,topicIndex)=>topicIndex!==index1);
      }
      return { ...cat }
    });

    const newEditingTemplate=templateModel({ ...editingTemplate, categories: newCats });
    return { ...state, editingTemplate: newEditingTemplate.final() }
    
    
  } else if(type === SAVE_TEMPLATE_TITLE) {
    const newTemplate={...editingTemplate,template:title}
    const newEditingTemplate=templateModel(newTemplate);
    return {...state,editingTemplate: newEditingTemplate}


  } else if(type === SET_TEMPLATE_EDITING) {
    const newEditingTemplate=templateModel(template);
    return {...state,editingTemplate: newEditingTemplate}


  } else if(type === SET_DEFAULT_TEMPLATES) {
    defaultTemplates=defaultTemplates.map(elem=>templateModel(elem).final());
    return {...state,defaultTemplates}
  } else if(type === SET_USER_TEMPLATES) {
    userTemplates=userTemplates.map(elem=>templateModel(elem).final());
    return {...state,userTemplates}
  } else if(type === SET_USER_TEMPLATES_STATUS) {
    return {...state,userTemplateStatus}

  } else if(type === SET_TEMPLATE_ERRORS_IDS) {
    return {...state,errorIds}
  }

  return state;
}